import PropTypes from "prop-types";
import React from "react";

import { useDeviceInfo } from "@swa-ui/browser";
import { applyOverrides, CallToAction, TextContent } from "@swa-ui/placements";

import styles from "./LuvStoriesPlacement.module.scss";

export const LuvStoriesPlacement = (props) => {
  const { placement } = props;
  const { backgroundColor, callToAction, graphic, text } = placement ?? {};
  const { description, label } = text ?? {};
  const { screenSize } = useDeviceInfo();

  return (
    <div className={styles.luvStoryContainer} style={{ backgroundColor }}>
      {graphic?.imagePath && renderGraphicImagePath()}
      <div className={styles.contentContainer}>
        <div className={styles.luvStoryContentContainer}>
          {label?.value && (
            <div className={styles.labelContainer}>
              <TextContent {...label} />
            </div>
          )}
          {description?.value && <TextContent {...description} />}
        </div>
        {callToAction && renderCallToAction()}
      </div>
    </div>
  );

  function renderGraphicImagePath() {
    const { altText, imagePath } = applyOverrides(graphic, screenSize);

    return <img alt={altText} className={styles.luvStoryImage} src={imagePath} />;
  }

  function renderCallToAction() {
    return (
      <div className={styles.callToAction}>
        <CallToAction {...callToAction} paddingForFocus={false} />
      </div>
    );
  }
};

LuvStoriesPlacement.displayName = "LuvStoriesPlacement";
LuvStoriesPlacement.propTypes = {
  /** Object that contains placement props, including backgroundColor, callToAction, etc */
  placement: PropTypes.shape({
    /** String that contains background color for the particular placement. */
    backgroundColor: PropTypes.string,

    /** Object that contains link/button props. */
    callToAction: PropTypes.object,

    /** Object that contains image props. */
    graphic: PropTypes.shape({
      altText: PropTypes.string,
      imagePath: PropTypes.string,
      overrides: PropTypes.shape({
        large: PropTypes.shape({
          altText: PropTypes.string,
          imagePath: PropTypes.string,
        }),
        medium: PropTypes.shape({
          altText: PropTypes.string,
          imagePath: PropTypes.string,
        }),
        small: PropTypes.shape({
          altText: PropTypes.string,
          imagePath: PropTypes.string,
        }),
      }),
    }),

    /** Object that contains description and label props. */
    text: PropTypes.shape({
      description: PropTypes.shape({
        value: PropTypes.string,
      }),
      label: PropTypes.shape({
        color: PropTypes.string,
        fontSize: PropTypes.string,
        fontWeight: PropTypes.string,
        value: PropTypes.string,
      }),
    }),
  }),
};
